import { render } from "./PaymentsDataTable.vue?vue&type=template&id=d363625a"
import script from "./PaymentsDataTable.vue?vue&type=script&lang=js"
export * from "./PaymentsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__